export default __webpack_public_path__ + "static/media/snow.4d944b0a.svg";